import React from 'react';
import { Loader2 } from 'lucide-react';
import { twMerge } from 'tailwind-merge';

interface LoadingScreenProps {
	message?: string;
	fullScreen?: boolean;
	name?: string;
	className?: string;
}

export function LoadingScreen({ message = 'Loading...', fullScreen = true, name, className }: LoadingScreenProps) {
	const containerClasses = fullScreen ? 'min-h-screen flex items-center justify-center bg-gray-50' : 'flex items-center justify-center p-8';

	return (
		<div className={twMerge(containerClasses, className)} id={name}>
			<div className="flex flex-col items-center gap-4">
				<div className="relative">
					<div className="flex size-12 items-center justify-center rounded-full bg-primary-100">
						<Loader2 className="size-6 animate-spin text-primary-600" />
					</div>
				</div>
				{message && <p className="font-medium text-gray-600">{message}</p>}
			</div>
		</div>
	);
}
